import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  dialogModal: {
    // paddingBottom: '3rem',
  },
  dialogModalOverlay: {
    zIndex: 99999,
  },
  dialogContainer: {
    margin: '0 auto',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-l)',
  },
  dialogBody: {
    '&:empty': {
      display: 'none',
    },
  },
  dialogTopButtons: {
    position: 'absolute',
    top: '0',
    right: '0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 'var(ui-spacer-s)',
  },
  dialogInfoButton: {
    padding: '2rem',
  },
  dialogInfoButtonImage: {
    display: 'block',
    margin: 0,
  },
  closeButton: {
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '3.2rem',
    aspectRatio: 1,
  },
  closeButtonIcon: {
    marginLeft: 0,
  },
  dialogTitle: {
    fontSize: '2.4rem',
    fontWeight: 'bold',
    lineHeight: 1.333,
    // marginBottom: '3rem',
  },
  dialogDescription: {
    fontSize: '1.6rem',
    lineHeight: 1.25,
    margin: '3rem 0 0.4rem',
    '&:first-child': {
      marginTop: 0,
    },
  },
  dialogHtml: {
    fontSize: '1.6rem',
    lineHeight: 1.5,
    color: 'var(--ui-color-text)',
    '& a': {
      color: 'var(--ui-color-link)',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        color: 'var(--ui-color-link-hover)',
      },
    },
    '& img': {
      margin: [['var(--ui-spacer-l)', 0]],
    },
    '& p': {
      margin: [['var(--ui-spacer-m)', 0]],
    },
    '& h1': {
      lineHeight: 1.18,
    },
    '& h2': {
      lineHeight: 1.18,
      fontSize: '3.4rem',
    },
    '& h3': {
      lineHeight: 1.18,
      fontSize: '2.8rem',
    },
    '& h4': {
      lineHeight: 1.18,
      fontSize: '2.4rem',
    },
    '& h5': {
      lineHeight: 1.18,
      fontSize: '2rem',
    },
    '& h6': {
      lineHeight: 1.18,
      fontSize: '1.6rem',
    },
    '& iframe, & p iframe': {
      height: 220,
    },
    '& ol': {
      listStyleType: 'decimal',
      listStylePosition: 'outside',
      marginLeft: 'var(--ui-spacer-m)',
    },
    '& ul': {
      listStyleType: 'disc',
      listStylePosition: 'outside',
      marginLeft: 'var(--ui-spacer-m)',
    },
  },
  dialogButtons: {
    maxWidth: '50rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-m)',
  },
  button: {
    // marginBottom: '1.6rem',
  },
}))

export default useStyles
